import { render } from "./ScreenTwo.vue?vue&type=template&id=52904037&scoped=true"
import script from "./ScreenTwo.vue?vue&type=script&lang=js"
export * from "./ScreenTwo.vue?vue&type=script&lang=js"

import "./ScreenTwo.vue?vue&type=style&index=0&id=52904037&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52904037"]])

export default __exports__